import styled from "styled-components";
import { DivContentPage } from "../../components/common/DivContentPage";

const DivMain = styled(DivContentPage)`
  //border: 4px solid red;
  .btnAddDriver {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    padding: 10px;
  }

  .btnFilterBalance {
    width: fit-content;
    height: 40px;
    border-radius: 10px;
    padding: 0 16px;
    font-weight: 600;
    font-size: 13px;
    margin-right: 8px;
  }

  .driversTable {
    .cellIndexCancellation {
      .cell-content {
        .txt-labelCell {
          display: flex;
          flex-direction: row;
          align-items: center;
          .txt-slash {
            font-family: inherit;
            font-weight: 700;
            font-size: 22px !important;
            font-size: inherit;
            cursor: inherit;
          }
        }
      }
      .div-contentTooltip {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        gap: 3px;
        //border: 1px solid red;
        .div-rowTxt {
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          gap: 5px;
        }
        .txt-title,
        .txt-value {
          font-family: "Roboto", Helvetica, sans-serif;
          font-weight: 400;
          font-size: 12px;
          line-height: 1.2;
          color: #13131d;
          text-align: left;
        }
        .txt-value {
          font-weight: 700;
          font-size: 14px;
        }
      }
    }
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  line-height: 1;
  text-align: center;
  
  &.pending {
    background-color: #FEF3C7;
    color: #D97706;
  }
  &.confirmed {
    background-color: #D1FAE5;
    color: #059669;
  }
  &.unknown {
    background-color: #F3F4F6;
    color: #4B5563;
  }
`;

const ModalBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(19, 19, 29, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
  animation: fadeIn 0.2s ease-out;

  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
`;

const ModalContent = styled.div`
  background-color: #ffffff;
  border-radius: 16px;
  width: 600px;
  max-width: 90%;
  max-height: 85vh;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  animation: slideUp 0.25s cubic-bezier(0.16, 1, 0.3, 1);

  @keyframes slideUp {
    from { transform: translateY(20px); opacity: 0; }
    to { transform: translateY(0); opacity: 1; }
  }
`;

const ModalHeader = styled.div`
  padding: 16px 20px;
  border-bottom: 1px solid #E5E7EB;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #111827;
  }
  span {
    font-size: 14px;
    color: #6B7280;
    margin-left: 10px;
  }
`;

const ModalBody = styled.div`
  padding: 20px;
  overflow-y: auto;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const ModalFooter = styled.div`
  padding: 16px 20px;
  border-top: 1px solid #E5E7EB;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  background-color: #F9FAFB;
`;

const BalanceDisplay = styled.div`
  background-color: #ECFDF5;
  border: 1px solid #A7F3D0;
  border-radius: 8px;
  padding: 12px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .label {
    font-size: 14px;
    color: #065F46;
    font-weight: 500;
  }
  .value {
    font-size: 20px;
    color: #047857;
    font-weight: 800;
  }
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
  }
  input {
    padding: 10px 12px;
    border: 1px solid #D1D5DB;
    border-radius: 8px;
    font-size: 14px;
    color: #111827;
    outline: none;
    transition: border-color 0.15s ease;

    &:focus {
      border-color: #10B981;
    }
  }
  span.help {
    font-size: 11px;
    color: #6B7280;
  }
`;

const TripsTableWrapper = styled.div`
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  overflow: hidden;
  max-height: 200px;
  overflow-y: auto;

  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13px;
    text-align: left;

    th, td {
      padding: 8px 12px;
      border-bottom: 1px solid #E5E7EB;
    }
    th {
      background-color: #F3F4F6;
      font-weight: 600;
      color: #374151;
      position: sticky;
      top: 0;
    }
    tr:last-child td {
      border-bottom: none;
    }
    td.money {
      font-weight: 600;
      color: #111827;
    }
  }
  .empty {
    padding: 20px;
    text-align: center;
    color: #6B7280;
    font-size: 13px;
  }
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: #9CA3AF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  border-radius: 6px;
  transition: background-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: #F3F4F6;
    color: #374151;
  }
`;

const styles = {
  DivMain,
  StatusBadge,
  ModalBackdrop,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  BalanceDisplay,
  FormField,
  TripsTableWrapper,
  CloseButton,
};

export default styles;

